import { render, staticRenderFns } from "./loginWrapper.vue?vue&type=template&id=7c47ff92&"
import script from "./loginWrapper.vue?vue&type=script&lang=js&"
export * from "./loginWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports